import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { Alert, AlertService } from '../alert.service';
import { StandardDialogComponent } from '../standard-dialog/standard-dialog.component';
//import { fa1 } from '@fortawesome/free-solid-svg-icons'

@Component({
    selector: 'alert-app',
    templateUrl: './alert.component.html',
    styleUrls: ['./alert.component.css'],
    standalone: false
})
export class AlertComponent implements OnInit {

  //public currentAlert: Alert;
  //public icon: string = "window-bar fas fa-exclamation-circle";
  //@Input() Message: String;
  //showAlert: Boolean;
  ModelWindowId: String | undefined;
  //testIcon = fa1;
  //AlertReceived: Subject<Alert>;//when subscribed this populates

  constructor(public alertService: AlertService) { 
    //his.AlertReceived = this.alertService.alerts;
  }

  ngOnInit() {
  }

}
